import { Box } from "@material-ui/core";
import { get } from "lodash";

import {
  AmountWithMultiple,
  Image,
  MarketplaceMedian,
  MediaPlayer,
} from "components";
import { getThumbnailUrlFromMediaUrl } from "components/MediaPlayer";
import { formatAmount, formatCurrencyAmount, formatNumber } from "lib/format";
import { InventoryListing } from "services/inventory/types";

import AssetDetails from "./components/AssetDetails";

export const formatListPriceOrSalePrice = (listing: InventoryListing) => {
  const isClosedListing = !!listing.deal_amount;
  const multiple = !!isClosedListing
    ? formatNumber(
        Number(listing.converted_deal_amount_or_list_price) /
          Number(listing.ltm),
        "",
        1,
      )
    : listing.list_price_multiple;

  return (
    <AmountWithMultiple
      amount={isClosedListing ? listing.deal_amount : listing.list_price}
      multiple={Number(multiple)}
      multipleSource={listing.list_price_multiple_source}
      currency={listing.currency}
      isClosedListing={isClosedListing}
    />
  );
};

export const formatAssetDetails = (listing: InventoryListing) => (
  <AssetDetails listing={listing} />
);

export const formatLTM = (listing: InventoryListing) =>
  formatAmount(listing.ltm, 0);

export const formatDollarAge = (order: InventoryListing) =>
  formatNumber(get(order, "dollarAge", get(order, "dollar_age")));

export const formatMarketplaceMedian = () => (listing: InventoryListing) => (
  <MarketplaceMedian
    marketplaceMedianSource={listing.marketplace_median_source}
    offer={listing.marketplace_median}
    multiplier={listing.marketplace_median_multiplier}
  />
);

export const formatMedia = (listing: InventoryListing) => {
  const thumbnailUrl = !!listing.thumbnail_url
    ? listing.thumbnail_url
    : getThumbnailUrlFromMediaUrl(listing.media_url);

  return !!listing.media_url || !!listing.thumbnail_url ? (
    <MediaPlayer
      mediaUrl={listing.media_url}
      thumbnailUrl={!!listing.thumbnail_url && thumbnailUrl}
      size="small"
    />
  ) : (
    <Box
      style={{
        backgroundColor: "black",
        height: "75px",
        width: "100px",
        margin: "auto",
        padding: "4px",
      }}
      display="flex"
      justifyContent="center"
    >
      <Image name="re-logo-white.svg" />
    </Box>
  );
};

export const formatHighestOpenOffer = (listing: InventoryListing) => (
  <AmountWithMultiple
    amount={listing.highest_open_offer_amount}
    multiple={Number(listing.highest_open_offer_amount) / Number(listing.ltm)}
    multipleSource="ltm"
    currency={listing.currency}
  />
);

export const formatHighestOpenOfferMobile = (listing: InventoryListing) =>
  formatCurrencyAmount(listing.currency, listing.highest_open_offer_amount);
